import React, { useState, useEffect } from "react";
import { Select, MenuItem, FormControl } from "@mui/material";
import { getWeightUnit } from "../../../http/api/MasterAPI";

const WeightUnitSelect = ({ onChange, value }) => {
  const [listWeightUnit, setListWeightUnit] = useState([]);
  const [selectedValue, setSelectedValue] = useState(value || null);

  async function getListWeightUnit() {
    try {
      const response = await getWeightUnit();
      const varList = response.masterVarInfo;
      const result = varList
        .map((element) => ({
          weightUnitId: element.varCd,
          weightUnitName: element.varValue1,
        }))
        .filter(
          (x) => x.weightUnitName && x.weightUnitName.trim() !== ""
        );
      setListWeightUnit(result);
    } catch (error) {
      console.error("担当者を取得するとき不具合発生した。", error);
    }
  }

  useEffect(() => {
    getListWeightUnit();
  }, []);

  useEffect(() => {
    setSelectedValue(value);
  }, [value]);

  const handleSelectionChange = (event) => {
    const newValue = event.target.value;
    setSelectedValue(newValue);
    if (onChange) {
      onChange(event);
    }
  };

  return (
    <>
      <Select
        value={selectedValue}
        onChange={handleSelectionChange}
        sx={{ width: 150 }}
      >
        <MenuItem key="unselected" value={null}>
          [未選択]
        </MenuItem>
        {listWeightUnit.map((item) => (
          <MenuItem
            key={item.weightUnitId}
            value={item.weightUnitId}
          >
            {item.weightUnitName}
          </MenuItem>
        ))}
      </Select>
    </>
  );
};

export default WeightUnitSelect;
